var map = {
	"./accenture.png": 142,
	"./annamalai.png": 143,
	"./apsis.svg": 144,
	"./b.png": 145,
	"./buld.jpg": 146,
	"./cathedral.png": 147,
	"./cwoc.png": 148,
	"./efi.png": 149,
	"./flutter.png": 150,
	"./gdg.png": 151,
	"./github.png": 152,
	"./googleAssistant.jpg": 153,
	"./google_logo.png": 154,
	"./gtu.png": 155,
	"./hackathon1.svg": 156,
	"./iit.png": 157,
	"./ino.png": 158,
	"./localguide.gif": 159,
	"./localguide.png": 160,
	"./microsoft.jpg": 161,
	"./mlh-logo.png": 162,
	"./mlh-logo.svg": 163,
	"./mlh.png": 164,
	"./mongo.png": 165,
	"./nightowls.jpg": 166,
	"./oracle.png": 167,
	"./pitneybowes.jpg": 168,
	"./postman.jpg": 169,
	"./postman.png": 170,
	"./precisely.jpg": 171,
	"./publicissapient.png": 172,
	"./rajat-favicon.png": 173,
	"./rajat.jpg": 174,
	"./rajat.png": 175,
	"./skillenza.png": 176,
	"./ssgandhy.png": 177,
	"./uptu.png": 178,
	"./valora.jpg": 179,
	"./wrighter.jpg": 180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;